import { Link } from "react-router-dom";
import { NavItemDataProps } from "../../types";
import { Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppDataWrapper from "../containers/AppDataWrapper";
import ImageFile from "../artifacts/ImageFile";

export default function LinksCardContainer({ menu }: { menu: NavItemDataProps }) {
    return <AppDataWrapper replaceMenu={menu}>
        {menu.description && <Typography sx={{ textAlign: 'center', maxWidth: '850px', margin: '2rem auto' }}>
            {menu.description}
        </Typography>}
        <div className={`link-cards ${menu.displayRow && 'rows'}`}>
            {menu.items?.map(i => <Link to={i.path || '/'} key={i.path} className='link-card'>
                <span className="link-card-icon">
                    {i.avatar ? <ImageFile loading="lazy" alt={'🎫'} width={32} height={32} src={i.avatar} /> :
                        <FontAwesomeIcon icon={i.icon || (i.items?.length ? 'sitemap' : 'circle-info')} />}
                </span>
                <span className="link-card-title">{i.label}</span>
                <Typography className="link-card-desc" component={'span'} sx={{ display: 'block' }} variant='caption'>
                    {handleDescription(i.description) || (i.items?.length ? `${i.items?.length} elementos` : '')}
                </Typography>
            </Link>)}
        </div>
    </AppDataWrapper>
}

function handleDescription(description?: string) {
    if (description && description.length > 100) {
        return `${description.slice(0, 97)}...`
    }
    return description
}